"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var OpacitySlider = function OpacitySlider(_ref) {
  var rgba = _ref.rgba,
    handleOpacitySlider = _ref.handleOpacitySlider,
    opacityValue = _ref.opacityValue,
    noColor = _ref.noColor;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-opacity-slider-wrapper")
  }, /*#__PURE__*/_react.default.createElement("input", {
    disabled: noColor,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-opacity-slider ").concat(noColor && "".concat(_Utils.PREFIX_CLASSNAME, "-disable-slider")),
    onChange: handleOpacitySlider,
    value: noColor ? 100 : opacityValue,
    min: "0",
    max: "100",
    step: "1",
    type: "range",
    style: {
      background: "linear-gradient(to right, transparent 0%, rgb(".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ") 100%)")
    }
  }));
};
var _default = OpacitySlider;
exports.default = _default;